import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue') },
  { path: '/embed', name: 'Embed', component: () => import('@/views/Embed.vue') }
]

export default new VueRouter({ mode: 'hash', routes })
